import type { ReactNode } from 'react'
import { observer } from 'mobx-react-lite'
import { useUi } from '@/stores/RootStore'
import { Button } from './Button'
import { ArrowRightIcon, MoonIcon, SunIcon, TelegramIcon } from './icons'
import styles from './Chrome.module.css'
import { SUPPORT_URL } from '@/shared/lib/contacts'

/** Контакт поддержки. Один на весь шлюз — в API его нет, см. разбор макета. */


/**
 * Оболочка публичных экранов: логотип, переключатель темы, подвал.
 *
 * Кабинет получит свою оболочку с навигацией; общее у них — тема
 * и тосты, и они живут в сторе, а не здесь.
 */
export const Chrome = observer(function Chrome({ children }: { children: ReactNode }) {
  const ui = useUi()

  return (
    <div className={styles.page}>
      <header className={styles.topbar}>
        <span className={styles.logo}>CryptoChangeK</span>
        <Button
          variant="icon"
          onClick={() => ui.toggleTheme()}
          aria-label={ui.theme === 'dark' ? 'Светлая тема' : 'Тёмная тема'}
        >
          {ui.theme === 'dark' ? <SunIcon /> : <MoonIcon />}
        </Button>
      </header>

      <main className={styles.middle}>{children}</main>

      <footer className={styles.foot}>
        {`© CryptoChangeK, ${new Date().getFullYear()}`}
      </footer>

    </div>
  )
})

export function TelegramCard() {
  return (
    <a className={styles.tg} href={SUPPORT_URL} target="_blank" rel="noopener noreferrer">
      <span className={styles.tgIcon}><TelegramIcon /></span>
      <span className={styles.tgBody}>
        <span className={styles.tgTitle}>Есть вопросы?</span>
        <span className={styles.tgNote}>Свяжитесь с нами в Telegram</span>
      </span>
      <span className={styles.tgGo}><ArrowRightIcon size={24} /></span>
    </a>
  )
}
